import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useToast,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useInviteOrgMemberMutation } from '../../Services/orgApi';

const roleOptions = ['viewer', 'editor', 'admin', 'owner'];

const InviteModal = ({ isOpen, onClose }) => {
  const account = useSelector((s) => s.account.account);
  const myRole = useSelector((state) => state.account.memberRole || 'viewer');
  const roleIndex = roleOptions.indexOf(myRole);
  const toast = useToast();

  const [inviteMember, inviteState] = useInviteOrgMemberMutation();
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('viewer');

  const onInvite = async () => {
    if (!account) return;
    await inviteMember({ accountId: account, email, role }).unwrap();
    toast({
      title: 'Invite sent',
      status: 'success',
      variant: 'left-accent',
      isClosable: true,
      position: 'top',
      duration: 3000,
    });
    onClose();
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Invite member</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex gap="12px" alignItems="end" flexWrap="wrap">
            <FormControl maxW="360px">
              <FormLabel fontSize="sm">Email</FormLabel>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@domain.com"
              />
            </FormControl>
            <FormControl maxW="200px">
              <FormLabel fontSize="sm">Role</FormLabel>
              <Select value={role} onChange={(e) => setRole(e.target.value)}>
                {roleOptions.map((r, i) => (
                  <option key={r} value={r} disabled={i > roleIndex}>{r}</option>
                ))}
              </Select>
            </FormControl>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr="8px" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onInvite} isLoading={inviteState.isLoading} isDisabled={!email} size="sm">
            Invite
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default InviteModal;
